import round from "../round";

/**
 * Spring easing
 * @param {Number} damping
 * @param {Number} stiffness
 * @returns {(arg0: Number) => Number}
 */
const spring = (damping, stiffness) => {
  /**
   *
   * @param {Number} t
   * @returns
   */
  const calcSpring = (t) => {
    return 1 - Math.exp(-stiffness * t) * Math.cos(damping * t);
  };

  return (t) => {
    return calcSpring(t);
  };
};

export default spring;